import * as Sentry from "@sentry/react";

export default function instrument() {
  if (!import.meta.env.REACT_APP_SENTRY_DSN) {
    return;
  }

  Sentry.init({
    dsn: import.meta.env.REACT_APP_SENTRY_DSN,
    release: import.meta.env.SENTRY_RELEASE,
    environment: import.meta.env.REACT_APP_SENTRY_ENVIRONMENT,

    integrations: [],

    // Set tracesSampleRate to 1.0 to capture 100% of transactions for tracing.
    // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
    tracesSampleRate: parseFloat(import.meta.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? "0.0"),
  });
}

export { captureException, withScope } from "@sentry/react";
